import request from '@/plugins/axios';
const controller = '/friend/';

// 选择好友
export function selectFriend(params){
    return request.post(controller + 'select_friend', params)
}

// 我的好友
export function myFriend(params){
    return request.post(controller + 'my_friend', params)
}

// 删除好友
export function delFriend(params){
    return request.post(controller + 'del_friend', params)
}

// 将好友移动到黑名单
export function blackFriend(params){
    return request.post(controller + 'black_friend', params)
}

// 好友请求
export function friendRequested(params){
    return request.post(controller + 'friend_requested', params)
}

// 添加好友
export function adoptFriend(params){
    return request.post(controller + 'adopt_friend', params)
}

// 拒绝好友请求
export function refuseFriend(params){
    return request.post(controller + 'refuse_friend', params)
}

// 黑名单
export function black(params){
    return request.post(controller + 'black', params)
}

// 添加好友
export function blackToFriend(params){
    return request.post(controller + 'add_friend', params)
}

// 删除黑名单
export function delBlack(params){
    return request.post(controller + 'del_black', params)
}

// 我的粉丝
export function fans(params){
    return request.post(controller + 'fans', params)
}

// 我的关注
export function follow(params){
    return request.post(controller + 'follow', params)
}

// 取消关注
export function delFollow(params){
    return request.post(controller + 'del_follow', params)
}

// 我的访客
export function visitor(params){
    return request.post(controller + 'visitor', params)
}

// 我的访问
export function visit(params){
    return request.post(controller + 'visit', params)
}